import config from './../config'

export const baseUrl = `${config.protocol}://${window.location.host}` + '/api'



// WEBPACK FOOTER //
// ./src/scripts/env.js